import type { ReactNode } from "react";
import "./StepBars.css";

export interface StepBarsProps {
  /** number of bars */
  total: number;
  /** how many bars are lit, starting from the left */
  current: number;
  /** small line under the bars, for example "Step 2 of 3" */
  caption?: ReactNode;
  className?: string;
}

/**
 * Progress shown as equal bars with a caption. Made for the dark side panels;
 * colours can be changed with --ds-steps-on, --ds-steps-track and
 * --ds-steps-caption.
 */
const StepBars = ({
  total,
  current,
  caption,
  className = "",
}: StepBarsProps) => (
  <div className={`ds-steps ${className}`.trim()}>
    <div className="ds-steps__bars" aria-hidden="true">
      {Array.from({ length: total }, (_, index) => (
        <span key={index} className={index < current ? "is-on" : ""} />
      ))}
    </div>
    {caption && <p className="ds-steps__caption">{caption}</p>}
  </div>
);

export default StepBars;
